import { BrowserRouter, Route, Routes } from "react-router-dom"
import Admin from "./views/Admin"
import Login from "./views/Login"

import rtlPlugin from "stylis-plugin-rtl"
import { CacheProvider } from "@emotion/react"
import createCache from "@emotion/cache"
import { prefixer } from "stylis"
import { auth, logout } from "./util/firebase"
import { useEffect, useRef } from "react"
import { useAuthState } from "react-firebase-hooks/auth"

const inactivityTimeMS = 1800000

// Create rtl cache
const cacheRtl = createCache({
	key: "muirtl",
	stylisPlugins: [prefixer, rtlPlugin],
})

function RTL(props) {
	return <CacheProvider value={cacheRtl}>{props.children}</CacheProvider>
}

function App() {
	const [user, loading] = useAuthState(auth)
	const inActivityLogoutRef = useRef(null)
	//const navigate = useNavigate()

	const setInactivityTimeout = () => {
		if (user) {
			const lastActivityTimestamp = new Date().getTime().toString()
			localStorage.setItem("lastActivityTimestamp", lastActivityTimestamp)
			if (inActivityLogoutRef.current) clearTimeout(inActivityLogoutRef.current)
			inActivityLogoutRef.current = setTimeout(async () => {
				checkForTimeout()
			}, inactivityTimeMS)
		}
	}

	const checkForTimeout = async () => {
		const currentTimeStamp = new Date().getTime()

		if (currentTimeStamp - parseInt(localStorage.getItem("lastActivityTimestamp")) > inactivityTimeMS) {
			if (process.env.NODE_ENV !== "development") {
				await logout()
				window.location.href = "/login"
			}
		}
	}

	useEffect(() => {
		if (loading) {
			// maybe trigger a loading screen
			return
		}
		setInactivityTimeout()
		return () => {
			if (inActivityLogoutRef.current) clearTimeout(inActivityLogoutRef.current)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user, loading])

	const resetInactivityLogout = async () => {
		setInactivityTimeout()
	}

	return (
		<RTL>
			<div id="App" onClick={() => resetInactivityLogout()}>
				<BrowserRouter>
					<Routes>
						<Route path="/" exact element={<Admin />} />
						<Route path="/login" element={<Login />} />
					</Routes>
				</BrowserRouter>
			</div>
		</RTL>
	)
}

export default App
